let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1m6vp")).then(() => parcelRequire('4LxZT'));